<template>
    <div>
        <div class="card mb-1">
            <div class="card-body pt-1">
                <div class="row d-flex justify-content-between">
                    <div>
                        <span class="text-muted text-uppercase font-medium-1 font-weight-bold">Tabel Monitoring
                            Perkin
                        </span>
                    </div>
                    <div class=" d-flex justify-content-end">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-primary" size="md"
                            @click="cetakExcelPerkin">
                            <feather-icon icon="PrinterIcon" class="mr-50" />
                            <span class="align-middle">Download Excel</span>
                        </b-button>
                    </div>
                </div>
                <div class="mt-2">
                    <vue-good-table theme="polar-bear" :columns="columns" :rows="rows" :pagination-options="{
                        enabled: true, perPage: row, jumpFirstOrLast: true,
                    }" :totalRows="totalRecords" :isLoading="isLoadingTable" mode="remote"
                        @on-sort-change="onSortChange">
                        <template slot="table-row" slot-scope="props">
                            <div v-if="props.column.field === 'aksi'" style="margin-left: 6px">
                                <b-button variant="primary" v-b-tooltip.hover title="Detail Perkin" class="btn-icon"
                                    @click="openDetailDataDialog(props)">
                                    <feather-icon icon="InfoIcon" />
                                </b-button>
                            </div>
                            <div v-else-if="props.column.field == 'jenis_perkin'">
                                <span class="text-capitalize">{{ props.formattedRow[props.column.field] }}</span>
                            </div>
                            <div v-else>
                                {{ props.formattedRow[props.column.field] }}
                            </div>
                        </template>
                        <template slot="pagination-bottom">
                            <div class="d-flex justify-content-between flex-wrap">
                                <div class="d-flex align-items-center mb-0 mt-1">
                                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                                    <b-form-select v-model="row" :options="['10', '25', '50']" class="mx-1"
                                        @input="handlePageChange" />
                                    <span class="text-nowrap">
                                        dari {{ totalRecords }} entri
                                    </span>
                                </div>
                                <div>
                                    <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number
                                        last-number align="right" prev-class="prev-item" next-class="next-item"
                                        class="mt-1 mb-0" @change="handleChangePage">
                                        <template #prev-text>
                                            <feather-icon icon="ChevronLeftIcon" size="18" />
                                        </template>
                                        <template #next-text>
                                            <feather-icon icon="ChevronRightIcon" size="18" />
                                        </template>
                                    </b-pagination>
                                </div>
                            </div>
                        </template>
                    </vue-good-table>
                </div>
            </div>
        </div>
        <ModalDetailPerkin :show="showModalDetailData" :data-modal="modalDetailData" @closeDialog="closeDetailDataDialog"
            @confirmDialog="confirmDetailDataDialog" />
    </div>
</template>
  
<script>
import { ref, watch } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { parserValue } from '@/libs/helper'
import { VueGoodTable } from "vue-good-table";
import vSelect from "vue-select";
import { VBTooltip, BButton } from 'bootstrap-vue'
import perkin from "@/composables/b/perkin";

import ModalDetailPerkin from '../components/ModalDetailPerkin.vue';

export default {
    props: {
        fd: { type: Object, required: true },
        parentFilter: { type: Object, required: true },
        isButtonClicked: { type: Boolean }
    },
    setup(props, context) {
        //global variable
        const g = context.root;
        const $route = g.$route;

        //variable untuk table
        const start = ref(0);
        const rows = ref([]);
        const row = ref(10);
        const totalRecords = ref(0);
        const sortColumn = ref("");
        const order = ref("");
        const isLoadingTable = ref(false);
        const formFilterTable = ref({
            tahun: [props.parentFilter.tahun],
            filter_wilayah: [props.parentFilter.wilayah],
            filter_kolok: [props.parentFilter.kolok],
            kolok: [props.parentFilter.kolok],
            limit: row.value,
            start: start.value,
            cari: null,
        });

        const filterValue = ref({
            tahun: null,
            filter_wilayah: null,
            filter_kolok: null,
            kolok: null,
            limit: row.value,
            start: start.value,
            cari: null,
        })
        const getData = () => {
            isLoadingTable.value = true;
            filterValue.value.tahun = props.parentFilter.tahun;
            filterValue.value.filter_wilayah = props.parentFilter.wilayah;
            filterValue.value.filter_kolok = props.parentFilter.kolok;
            filterValue.value.jenis_perkin = 'gabungan';

            perkin.getData(g, filterValue.value).then(resp => {
                if (resp.success) {
                    rows.value = resp.rows;
                    totalRecords.value = resp.totalRows;
                } else {
                    rows.value = [];
                    totalRecords.value = 0;
                }
                isLoadingTable.value = false;
            }).catch((err) => {
                console.log(err)
                isLoadingTable.value = false;
            });
        };
        if (props.parentFilter.kolok > 0) {
            getData();
        }

        const handleSearch = (searching) => {
            filterValue.value.start = 0;
            filterValue.value.cari = formFilterTable.value.cari;
            getData();
        };

        const handlePageChange = (length) => {
            filterValue.value.limit = length;
            getData();
        };

        const handleChangePage = (page) => {
            filterValue.value.start = (page - 1) * row.value;
            getData();
        };

        const onSortChange = (params) => {
            sortColumn.value = params[0].field;
            order.value = params[0].type;
            getData();
        };

        /* Modal Detail */
        const modalDetailData = ref({});
        const showModalDetailData = ref(false);
        const openDetailDataDialog = (item) => {
            showModalDetailData.value = true;
            modalDetailData.value = item.row;
            modalDetailData.value.tahun = props.parentFilter.tahun;
        };
        const closeDetailDataDialog = (item) => {
            showModalDetailData.value = false;
        };

        const confirmDetailDataDialog = () => {
            getData();
            showModalDetailData.value = false;
        };

        /* Cetak */
        const cetakExcelPerkin = () => {
            let fWilayah = (props.parentFilter.filter_wilayah) ? props.parentFilter.filter_wilayah : 'semua'; //delete later
            console.log(fWilayah);
            const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/perkin/excel?tahun=' + props.parentFilter.tahun + '&filter_wilayah=' + fWilayah + '&filter_kolok=' + props.parentFilter.kolok + '&jenis_perkin=gabungan'; // Replace with your specific link
            window.open(linkToOpen, '_blank');
        }
        return {
            parserValue,
            getData,
            /* Table */
            formFilterTable,
            filterValue,
            handleSearch,
            handlePageChange,
            handleChangePage,
            onSortChange,
            rows,
            start,
            row,
            totalRecords,
            sortColumn,
            order,
            isLoadingTable,

            /* Modal Detail Data */
            showModalDetailData,
            modalDetailData,
            openDetailDataDialog,
            closeDetailDataDialog,
            confirmDetailDataDialog,

            /* Cetak Ecel */
            cetakExcelPerkin

        };
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        VueGoodTable,
        vSelect,
        ModalDetailPerkin,
    },
    watch: {
        parentFilter: {
            handler(newVal, oldVal) {
                // this.getData();
            },
            deep: true
        },
        isButtonClicked(newValue) {
            console.log(newValue)
            this.getData();

            // if (newValue) {
            //     // Handle the event when the button is clicked
            //     console.log('Button was clicked');
            // } else {
            //     // Handle the event when the button is unclicked
            //     console.log('Button was unclicked');
            // }
        }
    },
    methods: {
        changeStateEvent(event) {
            this.$emit('changeStateEvent', event);
        },
    },
    data() {
        return {
            imgUrl: require('@/assets/images/pages/coming-soon.svg'),
            required,
            columns: [
                {
                    label: "",
                    field: "aksi",
                    width: '70px',
                    thClass: 'text-uppercase bg-light-primary pb-1 px-0 text-center',
                    sortable: false,
                },
                {
                    label: "Kolok",
                    field: "kolok",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Nalok",
                    field: "nalok",
                    width: '250px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "Jenis Perkin",
                    field: "jenis_perkin",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW I",
                    field: "result_tw1",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW II",
                    field: "result_tw2",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW III",
                    field: "result_tw3",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW IV",
                    field: "result_tw4",
                    width: '100px',
                    thClass: 'text-uppercase bg-light-primary pb-1',
                    sortable: false,
                },
                {
                    label: "TW I - 2025",
                    field: "result_tw5",
                    width: '150px',
                    thClass: 'text-uppercase bg-light-primary pb-1 text-center',
                    sortable: false,
                },
            ],
        };
    },
    directives: {
        'b-tooltip': VBTooltip,
        Ripple,
    },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>